import { useDeepCompareEffect } from "react-use"

import { type TEmptyCallback, emptyCallback } from "@/shared/types/functions"

import { ECoachingChatSocketListenerEventName as EListenerEventName } from "../../types"

import { coachingChatSocket as socket } from "./coaching-chat.api.socket"

type _TParams<TResponse = any> = {
    event: EListenerEventName
    handler(response: TResponse): void
    isEnabled: boolean
}

function useSocketReceiver<TResponse = any>({ event, handler, isEnabled }: _TParams<TResponse>): void {
    useDeepCompareEffect((): TEmptyCallback => {
        if (!isEnabled || !socket.connected) return emptyCallback

        socket.on(event as never, handler as never)

        return (): void => void socket.off(event as never, handler as never)
    }, [event, handler, isEnabled])
}

export { useSocketReceiver as useCoachingChatSocketReceiver }
